import type { IPlayerGlobalStateSlice } from './slice'
import { PLAYER_SLICE_KEY } from './slice'

/**
 *
 */
export function partializeForSessionStorage(state: IPlayerGlobalStateSlice) {
  const { videoStates } = state[PLAYER_SLICE_KEY]
  return {
    [PLAYER_SLICE_KEY]: {
      videoStates,
    },
  }
}

/**
 *
 */
export function merge(
  persistedState: IPlayerGlobalStateSlice,
  currentState: IPlayerGlobalStateSlice,
) {
  return {
    [PLAYER_SLICE_KEY]: {
      ...currentState[PLAYER_SLICE_KEY],
      ...persistedState[PLAYER_SLICE_KEY],
    },
  }
}
